/*!
* @magic-microservices/magic v1.1.3
*
* Copyright (c) 2020 Bytedance Inc.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classCallCheck = createCommonjsModule(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _classCallCheck = unwrapExports(classCallCheck);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _defineProperty = unwrapExports(defineProperty);

/**
  * Copyright (c) 2020 Bytedance Inc.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
function createHash(num) {
  var hashArr = new Array(num);

  for (var i = 0; i < num; i++) {
    hashArr[i] = (Math.random() * 16 | 0).toString(16);
  }

  return hashArr.join('');
}

var globalHeapKey = '__MAGIC_HEAP__';

var Heap = function Heap() {
  var _this = this;

  _classCallCheck(this, Heap);

  _defineProperty(this, "dataMap", {});

  _defineProperty(this, "useProps", function (value) {
    var propId = createHash(12); // 确保地址不重复

    while (Object.prototype.hasOwnProperty.call(_this.dataMap, propId)) {
      /* istanbul ignore next */
      propId = createHash(12);
    } // 数据入堆


    _this.dataMap[propId] = value;
    return propId;
  });

  _defineProperty(this, "getPropsValue", function (name, value) {
    var propTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (propTypes[name] === Boolean) {
      if (value === 'false') {
        return false;
      }

      return true;
    } else if (propTypes[name] === Number) {
      return Number(value);
    }

    if (_this.dataMap[value]) {
      // 放在堆中的引用类型数据
      var heapValue = _this.dataMap[value]; // 取出即回收

      delete _this.dataMap[value];
      return heapValue;
    }

    return value;
  });

  if (!window[globalHeapKey]) {
    window[globalHeapKey] = {};
  }

  this.dataMap = window[globalHeapKey];
};

var heap = new Heap();

var createClass = createCommonjsModule(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _createClass = unwrapExports(createClass);

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayLikeToArray);

var arrayWithoutHoles = createCommonjsModule(function (module) {
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayWithoutHoles);

var iterableToArray = createCommonjsModule(function (module) {
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(iterableToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(unsupportedIterableToArray);

var nonIterableSpread = createCommonjsModule(function (module) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(nonIterableSpread);

var toConsumableArray = createCommonjsModule(function (module) {
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _toConsumableArray = unwrapExports(toConsumableArray);

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _assertThisInitialized = unwrapExports(assertThisInitialized);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(setPrototypeOf);

var inherits = createCommonjsModule(function (module) {
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _inherits = unwrapExports(inherits);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(_typeof_1);

var possibleConstructorReturn = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _getPrototypeOf = unwrapExports(getPrototypeOf);

var isNativeFunction = createCommonjsModule(function (module) {
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(isNativeFunction);

var isNativeReflectConstruct = createCommonjsModule(function (module) {
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

module.exports = _isNativeReflectConstruct;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(isNativeReflectConstruct);

var construct = createCommonjsModule(function (module) {
function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _construct.apply(null, arguments);
}

module.exports = _construct;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(construct);

var wrapNativeSuper = createCommonjsModule(function (module) {
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _wrapNativeSuper(Class);
}

module.exports = _wrapNativeSuper;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _wrapNativeSuper = unwrapExports(wrapNativeSuper);

/**
  * Copyright (c) 2020 Bytedance Inc.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
function functionExecutor(callback) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof callback === 'function' ? callback.apply(void 0, args) : callback;
}

/**
 * Copyright (c) 2020 Bytedance Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * All html tag elements which must not contain innerHTML
 * @see https://www.w3.org/TR/html5/syntax.html#void-elements
 */
var voidTags = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];
function renderHtmlTagObjectToHtmlElement(tagDefinition) {
  var tagElement = document.createElement(tagDefinition.tagName);
  Object.keys(tagDefinition.attributes || {}).forEach(function (attributeName) {
    var _tagDefinition$attrib;

    tagElement.setAttribute(attributeName, ((_tagDefinition$attrib = tagDefinition.attributes) === null || _tagDefinition$attrib === void 0 ? void 0 : _tagDefinition$attrib[attributeName]) || '');
  });

  if (!tagDefinition.voidTag && tagDefinition.innerHTML) {
    tagElement.innerHTML = tagDefinition.innerHTML;
  }

  return tagElement;
}
function renderHtmlTagObjectsToFragment(tagDefinitions) {
  var fragment = document.createDocumentFragment();
  tagDefinitions.forEach(function (tagDefinition) {
    var element = renderHtmlTagObjectToHtmlElement(tagDefinition);
    fragment.appendChild(element);
  });
  return fragment;
}
function createHtmlTagObject(tagName, attributes, innerHTML) {
  return {
    tagName: tagName,
    voidTag: voidTags.indexOf(tagName) !== -1,
    attributes: attributes,
    innerHTML: innerHTML
  };
}
var tagMetaData = {
  scripts: function scripts(sourceUrl) {
    return createHtmlTagObject('script', {
      type: 'text/javascript',
      src: sourceUrl
    });
  },
  styles: function styles(sourceUrl) {
    return createHtmlTagObject('link', {
      rel: 'stylesheet',
      type: 'text/css',
      href: sourceUrl
    });
  }
};
function formatScripts8StylesTagAlias(type, tagOption) {
  if (typeof tagOption === 'string') {
    return tagMetaData[type](tagOption);
  }

  return tagOption;
}

/**
 * Copyright (c) 2020 Bytedance Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hook = function Hook() {
  var _this = this;

  _classCallCheck(this, Hook);

  _defineProperty(this, "tasks", void 0);

  _defineProperty(this, "tap", function (tasks) {
    var _this$tasks;

    tasks instanceof Array ? (_this$tasks = _this.tasks).push.apply(_this$tasks, _toConsumableArray(tasks)) : _this.tasks.push(tasks);
  });

  _defineProperty(this, "call", function (args) {
    return _this.tasks.reduce(function (preReturn, task) {
      return preReturn.then(function (data) {
        return task(args, data);
      });
    }, Promise.resolve(args));
  });

  this.tasks = [];
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MagicHooks;

(function (MagicHooks) {
  MagicHooks["beforeOptionsInit"] = "beforeOptionsInit";
  MagicHooks["alterHTMLTags"] = "alterHTMLTags";
  MagicHooks["beforeElementDefinition"] = "beforeElementDefinition";
})(MagicHooks || (MagicHooks = {}));

var hooks = Object.values(MagicHooks);
var AliasTagTypes;

(function (AliasTagTypes) {
  AliasTagTypes["scripts"] = "scripts";
  AliasTagTypes["styles"] = "styles";
})(AliasTagTypes || (AliasTagTypes = {}));

var CustomElementType = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomElementType, _HTMLElement);

  var _super = _createSuper(CustomElementType);

  function CustomElementType() {
    var _this;

    _classCallCheck(this, CustomElementType);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "shadow", void 0);

    return _this;
  }

  return CustomElementType;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var LifeCycle = function LifeCycle(magicInput) {
  var _this2 = this;

  _classCallCheck(this, LifeCycle);

  _defineProperty(this, "magicInput", void 0);

  _defineProperty(this, "name", void 0);

  _defineProperty(this, "options", void 0);

  _defineProperty(this, "module", void 0);

  _defineProperty(this, "customElement", void 0);

  _defineProperty(this, "hooks", {});

  _defineProperty(this, "componentBuilder", function () {
    return customElements.define(_this2.name, _this2.customElement);
  });

  _defineProperty(this, "run", function () {
    var runHook = new Hook();
    runHook.tap([_this2.generateModule, _this2.formatAliasTagTypes, _this2.defineCustomElement]);
    return runHook.call();
  });

  _defineProperty(this, "generateModule", function () {
    return _this2.hooks.beforeOptionsInit.call(_this2).then(function () {
      return Promise.resolve(functionExecutor(_this2.magicInput.module, _this2.name, _this2.options)).then(function (moduleObj) {
        _this2.module = moduleObj;
      });
    });
  });

  _defineProperty(this, "formatAliasTagTypes", function () {
    var options = _this2.options;
    Object.values(AliasTagTypes).forEach(function (tag) {
      var _options$tag;

      options[tag] = ((_options$tag = options[tag]) === null || _options$tag === void 0 ? void 0 : _options$tag.map(function (item) {
        return formatScripts8StylesTagAlias(tag, item);
      })) || [];
    });
    return _this2.hooks.alterHTMLTags.call(_this2);
  });

  _defineProperty(this, "buildFragment", function () {
    var _ref;

    var options = _this2.options;

    var renderHtmlTags = (_ref = options.htmlTags || []).concat.apply(_ref, _toConsumableArray(Object.values(AliasTagTypes).map(function (tagType) {
      return options[tagType];
    })));

    var htmlTagFragment = renderHtmlTagObjectsToFragment(renderHtmlTags);
    var contentWrapper = renderHtmlTagObjectToHtmlElement(createHtmlTagObject('div', {
      id: 'magic-wrapper',
      style: 'height: 100%; width: 100%;'
    }));
    htmlTagFragment.appendChild(contentWrapper);
    return {
      htmlTagFragment: htmlTagFragment,
      contentWrapper: contentWrapper
    };
  });

  _defineProperty(this, "defineCustomElement", function () {
    _this2.customElement = _this2.generateCustomElement();
    return _this2.hooks.beforeElementDefinition.call(_this2).then(_this2.componentBuilder);
  });

  _defineProperty(this, "generateCustomElement", function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var options = _this2.options,
        module = _this2.module,
        buildFragment = _this2.buildFragment;
    return /*#__PURE__*/function (_CustomElementType) {
      _inherits(CustomElement, _CustomElementType);

      var _super2 = _createSuper(CustomElement);

      function CustomElement() {
        var _this3;

        _classCallCheck(this, CustomElement);

        _this3 = _super2.call(this);

        _defineProperty(_assertThisInitialized(_this3), "attributesObj", {});

        _defineProperty(_assertThisInitialized(_this3), "webComponentsIns", void 0);

        _defineProperty(_assertThisInitialized(_this3), "contentWrapper", void 0);

        _defineProperty(_assertThisInitialized(_this3), "htmlTagFragment", void 0);

        _this3.webComponentsIns = options.shadow ? _this3.attachShadow({
          mode: 'open'
        }) : _assertThisInitialized(_this3);
        module.bootstrap && module.bootstrap(_assertThisInitialized(_this3));
        return _this3;
      }

      _createClass(CustomElement, [{
        key: "connectedCallback",
        value: function connectedCallback() {
          var _buildFragment = buildFragment(),
              contentWrapper = _buildFragment.contentWrapper,
              htmlTagFragment = _buildFragment.htmlTagFragment;

          this.contentWrapper = contentWrapper;
          this.htmlTagFragment = htmlTagFragment;
          this.webComponentsIns.appendChild(this.htmlTagFragment);
          module.mount(this.contentWrapper, this.attributesObj, this);
        }
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          module.unmount && module.unmount(this, this.contentWrapper);
        }
      }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(attributeName, _oldValue, newValue) {
          var _ref2;

          var oldAttributesObj = _objectSpread({}, this.attributesObj);

          var propsValue = heap.getPropsValue(attributeName, newValue, options.propTypes);
          var prevValue = this.attributesObj[attributeName];
          this.attributesObj[attributeName] = propsValue;
          (_ref2 = attributeName in oldAttributesObj ? module.updated : module.firstUpdated) === null || _ref2 === void 0 ? void 0 : _ref2(attributeName, propsValue, this.contentWrapper, this.attributesObj, this, prevValue);
        }
      }], [{
        key: "observedAttributes",
        get: // for attributeChangedCallback
        function get() {
          return Object.keys(options.propTypes || {});
        }
      }]);

      return CustomElement;
    }(CustomElementType);
  });

  this.magicInput = magicInput;
  this.name = this.magicInput.name;
  this.options = this.magicInput.options;
  hooks.forEach(function (hook) {
    _this2.hooks[hook] = new Hook();
  });
  var plugins = this.options.plugins || [];
  plugins.forEach(function (plugin) {
    return plugin.apply(_this2);
  });
};

/**
 * Copyright (c) 2020 Bytedance Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function magic(name, module) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lifeCycle = new LifeCycle({
    name: name,
    module: module,
    options: options
  });
  return lifeCycle.run();
}

var useProps = heap.useProps;
var isModuleRegistered = function isModuleRegistered(name) {
  return !(customElements.get(name) === undefined);
};

export default magic;
export { isModuleRegistered, useProps };
//# sourceMappingURL=index.esm.js.map
